import _isEqual from 'lodash/isEqual';

/**
 * Сравнивает два списка числовых id без учёта порядка (после сортировки по возрастанию).
 *
 * @param {number[]} idsLeft
 * @param {number[]} idsRight
 * @return {boolean}
 */
export default function sortedNumericIdsEqual(idsLeft, idsRight) {
  const sortedLeft = [ ...idsLeft ].sort((left, right) => left - right);
  const sortedRight = [ ...idsRight ].sort((left, right) => left - right);

  return _isEqual(sortedLeft, sortedRight);
}
